import script from "./chose-card.vue?vue&type=script&setup=true&lang=js"
export * from "./chose-card.vue?vue&type=script&setup=true&lang=js"

import "./chose-card.vue?vue&type=style&index=0&id=2f24e5ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f24e5ad"]])

export default __exports__